import { updateTaxAuditCover } from '../../slices/coverDetails';
import { AppDispatch } from '../../store';
import { Risk } from '../../types/policy';
import { RiskDetailBPKEmployeeDishonestyTaxAuditTransit } from '../../types/risk';

export const updateTaxAuditCoverAction = ({
  risk,
  dispatch,
}: {
  risk: Risk | undefined;
  dispatch: AppDispatch;
}) => {
  const riskBPKEmployeeDishonestyTaxAuditTransitDetail = (
    risk?.riskDetail as RiskDetailBPKEmployeeDishonestyTaxAuditTransit | undefined
  )?.riskBPKEmployeeDishonestyTaxAuditTransit;
  const sumInsured = riskBPKEmployeeDishonestyTaxAuditTransitDetail?.taxAudit?.taxAuditSI;
  if (sumInsured) {
    dispatch(updateTaxAuditCover({ sumInsured }));
  }
};
